<template>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue"

    export default {
        components: {
            FormBuilder
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                formData: [{
                        title: "Sites Mapping",
                        anchor: "4.1",
                        description: "Create an aggregation to combine sites",
                        forms: [
                            {
                                label: "Mapping",
                                type: "sectionarray",
                                value: "siteMappings",
                                grid: "grid-50w",
                                buttonText: "Add mapping",
                                forms: [{
                                    type: "guid",
                                    value: "id"
                                },{
                                    type: "select",
                                    label: "Dispensing Unit Mapping",
                                    value: "dispensingUnit",
                                    required: true,
                                    preValues: {
                                        field: "dispensingUnit.mappings",
                                        name: "name",
                                        value: "id"
                                    },
                                },{
                                    label: "Site Mapping",
                                    type: "sectionarray",
                                    value: "sites",
                                    grid: "grid-full",
                                    extraClass: "grid-full",
                                    buttonText: "Add site mapping",
                                    forms: [{
                                        type: "typeahead",
                                        label: "Select sites",
                                        value: "selectedRows",
                                        required: true,
                                        multiple: true,
                                        preValues: {
                                            field: "sites",
                                            name: "name",
                                            value: "id",
                                            groupBy: "studyName"
                                        },
                                    }]
                                }]
                            }
                        ]
                    },{
                        title: "Depots Mapping",
                        anchor: "4.2",
                        description: "Create an aggregation to combine depots",
                        forms: [
                            {
                                label: "Mapping",
                                type: "sectionarray",
                                value: "depotMappings",
                                grid: "grid-50w",
                                buttonText: "Add mapping",
                                forms: [{
                                    type: "guid",
                                    value: "id"
                                },{
                                    type: "select",
                                    label: "Dispensing Unit Mapping",
                                    value: "dispensingUnit",
                                    required: true,
                                    preValues: {
                                        field: "dispensingUnit.mappings",
                                        name: "name",
                                        value: "id"
                                    },
                                },{
                                    label: "Depot Mapping",
                                    type: "sectionarray",
                                    value: "sites",
                                    grid: "grid-full",
                                    extraClass: "grid-full",
                                    buttonText: "Add depot mapping",
                                    forms: [{
                                        type: "typeahead",
                                        label: "Select depots",
                                        value: "selectedRows",
                                        required: true,
                                        multiple: true,
                                        preValues: {
                                            field: "depots",
                                            name: "name",
                                            value: "id",
                                            groupBy: "studyName"
                                        },
                                    }]
                                }]
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>
